import { render, staticRenderFns } from "./AppMultiSelect.vue?vue&type=template&id=6627dccb"
import script from "./AppMultiSelect.vue?vue&type=script&lang=ts"
export * from "./AppMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports